
export class TeamSearchCriteria {
    public searchTerm: string;
    public selectedTimeframe: number;
}